module.exports = __webpack_public_path__ + "img/c7.1c417782.png";